import React, { PureComponent } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { cssMainSelector } from "../lib/cssSelectors";

const StyledFullComparatorLink = styled.span`
  ${p => cssMainSelector(p.theme.tdsId)} {
    display: inline-block;
    font-size: 90%;
    font-weight: ${p => p.theme.font.weightNormal};
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }
`;

class FullComparatorLink extends PureComponent {
  render() {
    const { clientConfig } = this.props;
    const showLink = clientConfig.options.showFullComparatorLink;
    const url = clientConfig.options.fullComparatorUrl;

    if (url != null && url !== "" && showLink) {
      return (
        <StyledFullComparatorLink>
          <a href={url}>{this.text()}</a>
        </StyledFullComparatorLink>
      );
    } else {
      return null;
    }
  }

  text() {
    const { short, t } = this.props;

    if (short) {
      return t("shortText");
    } else {
      return t("text");
    }
  }
}

export default withTranslation(["fullComparatorLink"])(FullComparatorLink);

FullComparatorLink.propTypes = {
  clientConfig: PropTypes.object.isRequired,
  short: PropTypes.bool
};
